// Module
var code = "<div class=\"locoPanel container\">\r\n    <div data-id=\"trainTitle\" class=\"title\"></div>\r\n    <div class=\"pageContent\">\r\n        <div data-id=\"speedContainer\" class=\"speedContainer\"></div>\r\n        <hr>\r\n        <div data-id=\"functionsContainer\"></div>\r\n    </div>\r\n</div>";
// Exports
export default code;